module.exports = __webpack_public_path__ + "static/banner-collaborators-8ed08c8d4f07a43516d0fa2dd0bc32ca.jpg";